var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonGroupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 67,
    viewBox: "0 0 93 67",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.748047 65.9008H53.4272C53.4272 48.0417 43.5797 36.397 33.2925 33.5097C40.0614 31.4255 44.9947 25.1156 44.9947 17.6775C44.9947 8.51854 37.5183 1.09961 28.3401 1.09961C19.1619 1.09961 11.6854 8.51854 11.6854 17.6775C11.6854 24.8097 16.198 30.8519 22.5272 33.2038C14.2286 35.0203 5.8152 42.3437 2.37337 54.084",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8984 65.9008C91.8984 48.0417 82.0509 36.397 71.8019 33.5097C78.5709 31.4255 83.485 25.1156 83.485 17.6775C83.485 8.51854 76.0277 1.09961 66.8495 1.09961C57.6713 1.09961 50.214 8.51854 50.214 17.6775C50.214 24.8097 54.7266 30.8519 61.0366 33.2038C55.9695 34.3128 50.8259 37.5252 46.8486 42.4967",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonGroupIcon);
export default __webpack_public_path__ + "static/media/person-group-icon.1b95543d.svg";
export { ForwardRef as ReactComponent };